import { Link } from 'react-router-dom';
import { stats } from '@/mocks/guagua';
import { formatViews, getFeatureArticle, getLatestArticles, getCategoryName } from '@/utils/content';

export default function HeroSection() {
  const featured = getFeatureArticle();
  const sideList = getLatestArticles(6)
    .filter((item) => item.id !== featured.id)
    .slice(0, 4);

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950" aria-labelledby="home-hero-title">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20collage%20background%20with%20soft%20coral%20and%20golden%20bokeh%20lights%2C%20floating%20paper%20cut%20organic%20shapes%20and%20confetti%2C%20energetic%20entertainment%20magazine%20aesthetic%2C%20blurred%20depth%20of%20field%2C%20large%20empty%20space%20in%20the%20center%2C%20no%20text&width=1600&height=900&seq=guagua-hero-2026&orientation=landscape"
          alt="瓜哥吃瓜今日份新鲜事氛围背景图"
          title="瓜哥吃瓜 - 今日份新鲜事"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/90 via-foreground-950/75 to-foreground-950/85"></div>

      <div className="relative w-full px-4 md:px-6 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-6xl mx-auto">
          <h1 className="sr-only">瓜哥吃瓜 - 今日份新鲜事，新瓜速递与最新更新快讯</h1>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-5">
                <i className="ri-fire-line" aria-hidden="true"></i>
                今日份新鲜事 · {getCategoryName(featured.categorySlug)}
              </span>
              <h2
                id="home-hero-title"
                className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight"
              >
                {featured.title}
              </h2>
              <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-xl">
                {featured.excerpt}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm text-background-300">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-3-line" aria-hidden="true"></i>
                  {featured.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line" aria-hidden="true"></i>
                  {featured.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" aria-hidden="true"></i>
                  {formatViews(featured.views)} 阅读
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {featured.readTime}
                </span>
              </div>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link
                  to={`/news/${featured.id}`}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  读这条瓜
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/news"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  查看全部新瓜速递
                </Link>
              </div>
            </div>

            <aside className="lg:col-span-5 w-full">
              <div className="rounded-lg bg-background-50/95 backdrop-blur p-5 md:p-6 border border-background-50/20">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">此刻最热</h3>
                  <span className="flex items-center gap-1 text-xs text-primary-600 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-soft"></span>
                    实时更新
                  </span>
                </div>
                <ol className="divide-y divide-background-200">
                  {sideList.map((item, index) => (
                    <li key={item.id}>
                      <Link
                        to={`/news/${item.id}`}
                        className="group flex items-start gap-3 py-3.5 cursor-pointer"
                      >
                        <span
                          className={`font-heading text-lg font-bold leading-none w-7 shrink-0 ${
                            index < 3 ? 'text-primary-500' : 'text-foreground-300'
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="flex-1">
                          <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                            {item.title}
                          </span>
                          <span className="block mt-1 text-xs text-foreground-400">
                            {getCategoryName(item.categorySlug)} · {formatViews(item.views)} 阅读
                          </span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </ol>
                <Link
                  to="/news"
                  className="mt-2 flex items-center justify-center gap-1 w-full py-2.5 rounded-md bg-background-100 text-sm font-medium text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  更多热瓜
                  <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                </Link>
              </div>
            </aside>
          </div>

          <dl className="mt-10 md:mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 pt-8 border-t border-background-50/15">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="text-xs md:text-sm text-background-300">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl md:text-3xl font-bold text-background-50">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}